export default __webpack_public_path__ + "static/media/Coder_img.37461588.jpg";